import { ApplicationConfig } from '@angular/core';
import { provideStore } from '@ngrx/store';
import { devToolsOptions, metaReducers, ROOT_REDUCER_TOKEN, runtimeChecks } from './store/store.config';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { provideRouter } from '@angular/router';
import { APP_ROUTING } from './app.routes';
import { AuthEffects } from './store/effects/auth.effects';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranscriptionEffects } from './store/effects/transcription.effects';
import { apiInterceptor } from './core/interceptors/api.interceptor';
import { accessDeniedInterceptor } from './core/interceptors/access-denied.interceptor';
import { ConversationDataEffects } from './store/effects/conversation-data.effects';
import { ApplicationEffects } from './store/effects/application.effects';
import { ScorecardEffects } from './store/effects/scorecard.effects';
import { DatePipe } from '@angular/common';
import { ClaimsEffects } from './store/effects/claim.effects';
import { AgentsEffects } from './store/effects/agents.effects';
import { ReprocessEffects } from './store/effects/reprocess.effects';
import { PdfExportEffects } from './store/effects/pdf-export.effects';

export const appConfig: ApplicationConfig = {
  providers: [
    provideEffects([
      AuthEffects,
      TranscriptionEffects,
      ConversationDataEffects,
      ApplicationEffects,
      ScorecardEffects,
      ClaimsEffects,
      AgentsEffects,
      ReprocessEffects,
      PdfExportEffects,
    ]),
    provideStore(ROOT_REDUCER_TOKEN, { metaReducers, runtimeChecks }),
    provideHttpClient(withInterceptors([apiInterceptor, accessDeniedInterceptor]), withInterceptorsFromDi()),
    provideStoreDevtools(devToolsOptions),
    ConfirmationService,
    MessageService,
    DatePipe,
    provideRouter(APP_ROUTING),
    provideAnimations(),
    { provide: Window, useValue: window },
    provideOAuthClient({
      resourceServer: {
        sendAccessToken: true,
      },
    }),
  ],
};
